import { createSlice } from '@reduxjs/toolkit';

import type { OAuth2Token } from './types';

export const slice = createSlice({
    initialState: {
        isQuickbooksConnected: false as boolean,
        quickbooksToken: null as OAuth2Token | null
    },

    name: 'useQuickbooks',

    reducers: {
        isQuickbooksConnected: (state, action) => {
            state.isQuickbooksConnected = action.payload;
        },

        quickbooksToken: (state, action) => {
            state.quickbooksToken = action.payload;
        }
    }
});

export default slice.reducer;
